module.exports = __webpack_public_path__ + "img/fa-4@3x.2557c403.png";